import { Label as LabelPrimitive } from 'radix-ui'
import type * as React from 'react'

import { cn } from '../../lib/utils'

/**
 * A field label (DESIGN.md §5 "Inputs and fields"): 13px weight 500 in ink,
 * above its field, in sentence case (The Sentence Case Rule: no uppercase in
 * the chrome, so English and Arabic read alike).
 *
 * `required` adds the red asterisk. It is `aria-hidden`: the field itself
 * carries `required` or `aria-required`, which is what a screen reader
 * announces, so the star is never read out as "star".
 */
function Label({
  className,
  children,
  required = false,
  ...props
}: React.ComponentProps<typeof LabelPrimitive.Root> & { required?: boolean }) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        'flex items-baseline gap-1 text-label text-foreground select-none',
        'group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:text-muted-foreground',
        'peer-disabled:cursor-not-allowed peer-disabled:text-muted-foreground',
        className,
      )}
      {...props}
    >
      {children}
      {required ? (
        <span data-slot="label-required" aria-hidden="true" className="text-danger">
          *
        </span>
      ) : null}
    </LabelPrimitive.Root>
  )
}

export { Label }
